import { useState, useEffect } from 'preact/hooks'

export function Toast({ message, type = 'warning', duration = 4000, onClose }) {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
      setTimeout(() => onClose && onClose(), 300) // Wait for fade-out animation
    }, duration)

    return () => clearTimeout(timer)
  }, [duration, onClose])

  const handleClose = () => {
    setIsVisible(false)
    setTimeout(() => onClose && onClose(), 300)
  }

  const typeStyles = {
    warning: 'bg-editions-orange/90 border-editions-orange/50',
    success: 'bg-editions-green/90 border-editions-green/50',
    info: 'bg-editions-purple/90 border-editions-purple/50'
  }

  return (
    <div className={`
      fixed top-20 right-4 z-50 max-w-sm p-4 rounded-lg border backdrop-blur-lg
      text-white shadow-lg transition-all duration-300 transform
      ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}
      ${typeStyles[type]}
    `}>
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 text-xl">
          {type === 'warning' && '⚠️'}
          {type === 'success' && '✅'}
          {type === 'info' && 'ℹ️'}
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium leading-snug">{message}</p>
        </div>
        <button
          onClick={handleClose}
          className="flex-shrink-0 text-white/70 hover:text-white transition-colors"
          aria-label="Close notification"
        >
          ✕
        </button>
      </div>
    </div>
  )
} 